import axios from "axios";
import type { ScheduleAlertOut } from "@/pages/human-resources/time-management/endpoints/alerts/inout/ScheduleAlertOut.ts";

export async function readSchedulesAlerts(
  siteId: string,
  employeesIds: number[],
  startDate: Date,
  endDate: Date,
): Promise<ScheduleAlertOut[]> {
  if (employeesIds.length === 0) return [];
  const { data } = await axios.post<ScheduleAlertOut[]>(
    "/api/hr/schedules/alerts",
    {
      siteId: parseInt(siteId),
      employeesIds: Array.from(employeesIds.values()),
      scheduleType: "SCHEDULE",
      startDate: startDate.toISOString(),
      endDate: endDate.toISOString(),
    },
  );
  return data;
}
